import React, { HTMLProps, RefObject, useState } from 'react'
import { twMerge } from 'tailwind-merge'
import { Waypoint } from 'react-waypoint'
import { useIsFirefox, useIsMobile, useIsSafari } from '../../../utils/helpers'

interface MovingHeaderProps extends HTMLProps<HTMLDivElement> {
  backgroundRef?: RefObject<any>
  component?: string
  mobileComponent?: string
  size: MovingHeaderSize
  animate?: boolean
  backgroundProps?: HTMLProps<HTMLElement>
}

export enum MovingHeaderSize {
  SMALL,
  BIG,
}
const MovingHeader = ({
    backgroundRef,
    component,
    className,
    mobileComponent,
    size,
    animate = false,
    backgroundProps,
}: MovingHeaderProps) => {
    const [isVisible, setIsVisible] = useState(false)
    const isMobile = useIsMobile()
    const isSafari = useIsSafari()
    const isFirefox = useIsFirefox()

    const getComponent = (cmp: string) => {
        const className = 'transition-transform ease-in-out duration-700 w-full h-full'

        return !isSafari && !isFirefox ? (
            <object data={cmp} className={className} ref={backgroundRef} {...backgroundProps} />
        ) : (
        // @ts-ignore
            <img
                src={cmp}
                className={className}
                ref={backgroundRef}
                {...backgroundProps}
                alt={'page-background'}
            />
        )
    }

    return (
        <Waypoint onEnter={() => setIsVisible(true)} onLeave={() => setIsVisible(false)}>
            <div
                className={twMerge(
                    'absolute pointer-events-none',
                    size === MovingHeaderSize.BIG ? 'moving-header' : 'moving-header-small',
                    animate &&
            'transition duration-[1500ms] ease-[cubic-bezier(0.470, -0.020, 0.000, 1.350)] delay-200',
                    className,
                )}
                style={
                    animate ? { transform: isVisible ? 'translateX(0%)' : 'translateX(50%)' } : undefined
                }
            >
                <div className='w-full h-full flex items-center justify-center'>
                    {component && !isMobile && getComponent(component)}
                    {mobileComponent && isMobile && getComponent(mobileComponent)}
                </div>
            </div>
        </Waypoint>
    )
}

export default MovingHeader
